"use client";

import { Building2, Leaf, House as Home, Sprout } from 'lucide-react';
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Separator } from "@/components/ui/separator";
const disciplines = [{
  number: "01",
  name: "Residential Construction",
  description: "Building quality residential projects  with precision, durability, and attenton to detail. We are committed to delivering safe, reliable, and efficent construction solutions.",
  icon: Home,
  offset: "md:translate-y-8"
}, {
  number: "02",
  name: "Commercial Construction",
  description: "Providing dependable commercial construction services designed for durability, efficiency, and the unique requirements of every project.",
  icon: Building2,
  offset: "md:-translate-y-8"
}, {
  number: "03",
  name: "Concrete Formwork",
  description: "Specializing in concrete formwork for residential, commercial, and industrial projects. We deliver precision, structural integrity, and quality workmanship on every job..",
  icon: Sprout,
  offset: "md:-translate-y-8"
}, {
  number: "04",
  name: "Skilled Workforce",
  description: "Our experienced and safety-focused workforce is committed to delivering quality craftsmanship, professionalism, and reliable performance on every project.",
  icon: Leaf,
  offset: "md:translate-y-8"
}];
export default function Services() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return <section data-section-id="5060" id="soluciones-estructurales" className="relative py-24 md:py-40 overflow-hidden bg-background text-foreground">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {}
        <div ref={headerRef} className={`transition-all duration-1000 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <p className="font-mono text-xs md:text-sm tracking-[0.1em] uppercase mb-16 md:mb-24 text-primary">&nbsp;SERVICES</p>

          {}
          <div className="grid grid-cols-12 mb-20 md:mb-32">
            <h2 className="col-span-12 md:col-start-2 md:col-end-12 font-default text-5xl md:text-7xl lg:text-8xl leading-[1.1] text-center font-bold">CONCRETE FORMWORK EXPERTS IN <span className="text-destructive">VANCOUVER</span></h2>
          </div>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 lg:gap-16">
          {disciplines.map((discipline, i) => {
          const Icon = discipline.icon;
          return <DisciplineCard key={discipline.number} data-index={i} discipline={discipline} Icon={Icon} index={i} />;
        })}
        </div>
      </div>
    </section>;
}
function DisciplineCard({
  discipline,
  Icon,
  index,
  ...rest
}: {
  discipline: {
    number: string;
    name: string;
    description: string;
    offset: string;
  };
  Icon: React.ComponentType<{
    className?: string;
    strokeWidth?: number;
  }>;
  index: number;
  [key: string]: any;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <div ref={ref} {...rest} className={`${discipline.offset} transition-all ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
    transitionDuration: "900ms",
    transitionDelay: `${index * 150}ms`
  }}>
      <div className="group relative p-10 md:p-12 h-full transition-transform duration-500 ease-out border-l-4 border-primary bg-card">
        {}
        <div className="flex items-start justify-between mb-10">
          <div className="transition-transform duration-700 ease-out text-primary">
            <Icon className="w-12 h-12 md:w-14 md:h-14" strokeWidth={1.5} />
          </div>
          <span className="font-default text-2xl md:text-3xl font-bold text-foreground">
            {discipline.number}
          </span>
        </div>

        {}
        <h3 className="font-default text-4xl md:text-5xl font-bold leading-[1.1] mb-8 text-foreground">
          {discipline.name}
        </h3>

        {}
        <Separator className="mb-8 h-[2px] bg-primary" />

        {}
        <p className="font-default text-lg md:text-xl leading-relaxed font-normal text-muted-foreground">
          {discipline.description}
        </p>
      </div>
    </div>;
}